<template>
  <div id="customer-group-page" class="mkt-ops -main-font">
    <div :class="checkBackdrop ? 'bg-backdrop' : ''"></div>
    <div
      style="position: absolute;top: 50%; left: 50%; width: 10%; z-index: 7;"
      v-show="loadData == true"
    >
      <md-progress-spinner
        :md-stroke="8"
        :md-diameter="65"
        md-mode="indeterminate"
      ></md-progress-spinner>
    </div>

    <div class="head-title-page md-layout">
      <div
        :class="
          isAdd
            ? 'md-layout-item md-large-size-20 md-medium-size-20 md-small-size-20 head-label'
            : 'md-layout-item md-large-size-30 md-medium-size-30 md-small-size-30 head-label'
        "
      >
        Customer Group
      </div>
      <div
        class="md-layout-item md-large-size-20 md-medium-size-20 md-small-size-20 pageneg"
      >
        <!-- <div v-if="showPagenation">
          <md-button
            class="md-icon-button md-raised btn-page"
            @click="back()"
            ref="btnBack"
          >
            <md-icon>keyboard_arrow_left</md-icon>
          </md-button>
          <md-button
            class="md-icon-button md-raised btn-page"
            @click="next()"
            ref="btnNext"
          >
            <md-icon>keyboard_arrow_right</md-icon>
          </md-button>
        </div> -->
      </div>
      <div
        class="md-layout-item md-large-size-20 md-medium-size-20 md-small-size-15 pageneg-span"
      >
        <!-- <span v-if="showPagenation">{{ displayItem() }}</span> -->
      </div>
      <div class="md-layout-item filter-table">
        <input
          type="text"
          v-model="pagination.keyword"
          placeholder="Search by group name, create by, customer code"
          @input="searchOnTable"
        />
      </div>
      <div
        class="md-layout-item md-large-size-10 md-medium-size-10 md-small-size-10 add-group"
        v-if="isAdd"
      >
        <md-button class="md-raised md-primary" @click="addGroup()"
          >+ Add GROUP</md-button
        >
      </div>
    </div>

    <div id="table-customer-group">
      <div id="divTableHead">
        <div style="width: 22%;">Group Name</div>
        <div style="width: 11%; text-align: center;">Number of member</div>
        <!-- <div style="width: 20%">Campaign</div>
        <div style="width: 20%">Promotion</div> -->
        <div style="width: 10%; text-align: center;">Status</div>
        <div style="width: 14%;">Create By</div>
        <div style="width: 13%;">Create Date</div>
        <div style="width: 14%;">Modify By</div>
        <div style="width: 13%;">Modify Date</div>
        <div style="width: 3%; padding: 0px;"></div>
      </div>
      <div id="divTableBody" @scroll="handleScroll">
        <div
          :class="'row-bg-gray'"
          v-for="(item, rIndex) in dataCustomerGroup"
          :key="rIndex"
        >
          <div style="width: 22%;" :title="item.group_name" class="-font-kanit">
            {{ item.group_name }}
          </div>
          <div style="width: 11%; text-align: center;">
            {{ item.member.toLocaleString() }}
          </div>
          <!-- <div style="width: 20%">{{ displayName(item.campaigns) }}</div>
          <div style="width: 20%">{{ displayName(item.promotions) }}</div> -->
          <div style="width: 10%; text-align: center;">{{ item.status }}</div>
          <div style="width: 14%;" class="-font-kanit">
            {{ item.create_by }}
          </div>
          <div style="width: 13%;" class="-font-kanit">
            {{ item.create_date }}
          </div>
          <div style="width: 14%;" class="-font-kanit">
            {{ item.modify_by }}
          </div>
          <div style="width: 13%;" class="-font-kanit">
            {{ item.modify_date }}
          </div>
          <div style="width: 3%; padding: 0px;">
            <md-menu md-align-trigger style="padding: 0px;">
              <md-button class="md-icon-button more-vert" md-menu-trigger>
                <md-icon class="more-vert">more_vert</md-icon>
              </md-button>
              <md-menu-content class="menu-vert-volume">
                <md-menu-item @click="onSelect(item, 'edit')">
                  <span>Edit Customer Group</span>
                </md-menu-item>
                <md-menu-item @click="onSelect(item, 'view')">
                  <span>View Campaign and Promotion</span>
                </md-menu-item>
              </md-menu-content>
            </md-menu>
          </div>
        </div>
      </div>
      <div class="footer-table">
        number of lines in page ({{ dataCustomerGroup.length }})
      </div>
    </div>

    <md-dialog
      :md-active.sync="showSidepanel"
      class="customer-group-dialog"
      :md-click-outside-to-close="false"
    >
      <md-dialog-title>
        <div class="title-panel">{{ titlePanel }}</div>
        <!-- <md-menu
          md-size="big"
          v-if="
            mode == 'info' && (isEdit || isDelete) && isOwner(customerGroup)
          "
        > -->
        <md-menu md-size="big" v-if="mode === 'info'">
          <md-button class="md-icon-button more-vert" md-menu-trigger>
            <md-icon>more_vert</md-icon>
          </md-button>
          <md-menu-content class="menu-vert">
            <md-menu-item @click="editGroup()" v-if="isEdit">
              <span>Edit</span>
            </md-menu-item>
            <md-menu-item @click="deleteGroup()" v-if="isDelete">
              <span>Delete</span>
            </md-menu-item>
          </md-menu-content>
        </md-menu>
        <!-- <div v-else style="height: 25px;"></div> -->
        <div v-if="mode == 'add' || mode == 'edit'" style="height: 25px;"></div>
      </md-dialog-title>

      <FormCustomerGroup
        ref="formGroup"
        v-if="mode == 'add' || mode == 'edit'"
        :action="action"
        v-model="customerGroup"
      ></FormCustomerGroup>

      <InfoCustomerGroup
        v-if="mode == 'info'"
        v-model="customerGroup"
        @onDelete="deleteGroup"
      ></InfoCustomerGroup>

      <md-dialog-actions class="-action">
        <md-button class="-cancel" @click="closePanel()">CLOSE</md-button>
        <md-button
          class="md-primary -confirm"
          @click="saveGroup()"
          v-if="mode != 'info'"
          >SAVE</md-button
        >
      </md-dialog-actions>
    </md-dialog>

    <md-dialog
      :md-active.sync="showDetail"
      :md-backdrop="true"
      class="cg-view-dialog"
      :md-click-outside-to-close="false"
    >
      <div :class="checkBackdrop ? 'bg-backdrop' : ''"></div>
      <md-dialog-title>
        <div
          class="title-panel"
          style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
        >
          User customer group : {{ groupName }}
        </div>
      </md-dialog-title>

      <!-- <md-tabs>
        <md-tab md-label="PROMOTION">
          <div
            :class="'-row row-bg-gray'"
            v-for="(item, pIndex) in detailPromotion"
            :key="pIndex"
          >
            <div class="index">{{ pIndex + 1 }} &nbsp; :</div>
            <div class="detail">{{ item.promotion_code }}</div>
          </div>
        </md-tab>

        <md-tab md-label="CAMPAIGN">
          <div
            :class="'-row row-bg-gray'"
            v-for="(item, cIndex) in detailCampaign"
            :key="cIndex"
          >
            <div class="index">{{ cIndex + 1 }} &nbsp; :</div>
            <div class="detail">{{ item.campaign_title }}</div>
          </div>
        </md-tab>
      </md-tabs> -->

      <div class="md-layout">
        <div class="md-layout-item">
          <md-card class="mktops-tab">
            <md-card-content>
              <div>
                <div
                  :class="
                    valueTab == 'Promotion' ? 'tab-active' : 'tab-in-active'
                  "
                  @click="onClickTab('Promotion')"
                >
                  PROMOTION
                  <span class="tab-chip -chipgray">{{
                    detailPromotion.length
                  }}</span>
                </div>
                <div
                  :class="
                    valueTab == 'Campaign' ? 'tab-active' : 'tab-in-active'
                  "
                  @click="onClickTab('Campaign')"
                >
                  CAMPAIGN
                  <span class="tab-chip -chipgray">{{
                    detailCampaign.length
                  }}</span>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>

      <div class="md-layout">
        <div
          class="md-layout-item -table"
          style="width: -webkit-fill-available; padding: 20px;"
        >
          <div
            v-show="valueTab == 'Promotion'"
            :class="'-row row-bg-gray'"
            v-for="(item, pIndex) in detailPromotion"
            :key="'A' + pIndex"
          >
            <div class="index">{{ pIndex + 1 }} &nbsp; :</div>
            <div class="detail" style="font-size: 14px; font-family: kanit;">
              {{ item.promotion_code }}
            </div>
          </div>
          <div v-show="valueTab == 'Promotion' && detailPromotion.length < 1">
            <div style="color: #9a9a9a; padding: 0px 20px;">
              No Data Promotion.
            </div>
          </div>

          <div
            v-show="valueTab == 'Campaign'"
            :class="'-row row-bg-gray'"
            v-for="(item, cIndex) in detailCampaign"
            :key="'B' + cIndex"
          >
            <div class="index">{{ cIndex + 1 }} &nbsp; :</div>
            <div class="detail" style="font-size: 14px; font-family: kanit;">
              {{ item.campaign_title }}
            </div>
          </div>
          <div v-show="valueTab == 'Campaign' && detailCampaign.length < 1">
            <div style="color: #9a9a9a; padding: 0px 20px;">
              No Data Campaign.
            </div>
          </div>
        </div>
      </div>

      <md-dialog-actions class="-action">
        <md-button class="-cancel" @click="onClickClose()">CLOSE</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog-confirm
      :md-active.sync="dlgConfirmDelete"
      :md-click-outside-to-close="false"
      md-content="Do you want to delete Customer Group ?"
      md-confirm-text="Delete"
      md-cancel-text="Cancel"
      @md-cancel="onCancel"
      @md-confirm="onConfirmDelete"
    />
    <!-- <md-dialog-alert :md-active.sync="dlgAlert" :md-click-outside-to-close="false" :md-title=dlgAlertTitle :md-content=dlgAlertDetail /> -->
    <md-dialog-confirm
      :md-active.sync="dlgConfirm"
      :md-click-outside-to-close="false"
      md-content="Do you want to save Customer Group ?"
      md-confirm-text="Save"
      md-cancel-text="Close"
      @md-cancel="onCancel"
      @md-confirm="onConfirmSaveGroup"
    />
    <md-dialog-confirm
      :md-active.sync="dlgAlert"
      :md-click-outside-to-close="false"
      :md-title="dlgAlertTitle"
      :md-content="dlgAlertDetail"
      md-confirm-text="OK"
      md-cancel-text=""
      @md-confirm="onOkWarning"
    />

    <md-snackbar
      :md-position="position"
      :md-duration="isInfinity ? Infinity : duration"
      :md-active.sync="showSnackbar"
      md-persistent
    >
      <span>{{ dContent }}</span>
      <md-button class="md-primary" @click="showSnackbar = false">OK</md-button>
    </md-snackbar>
    <md-dialog-confirm
      :md-active.sync="showDialogCancel"
      :md-click-outside-to-close="false"
      md-content="Are you sure you want to close ?"
      md-confirm-text="OK"
      md-cancel-text="CANCEL"
      @md-cancel="onCancel"
      @md-confirm="onConfirm"
    />
  </div>
</template>

<script>
import _ from "lodash";
import customerGroupService from "@/services/customer_group";
// import FormCustomerGroup from "./customer-group/form";
// import InfoCustomerGroup from "./customer-group/info";
import FormCustomerGroup from "./customer-group/cg-form";
import InfoCustomerGroup from "./customer-group/cg-info";

export default {
  name: "cusgomer-group",
  components: {
    FormCustomerGroup,
    InfoCustomerGroup
  },
  computed: {
    permit() {
      return this.$jwt.decode(localStorage.getItem("token"));
    },
    isAdd() {
      return this.permit.acl["setting"].menus["customer-group"].add;
    },
    isEdit() {
      return this.permit.acl["setting"].menus["customer-group"].edit;
    },
    isDelete() {
      return this.permit.acl["setting"].menus["customer-group"].delete;
    },
    user() {
      return this.$jwt.decode(localStorage.getItem("token"));
    }
  },
  data() {
    return {
      showPagenation: true,
      loadData: false,
      checkBackdrop: false,
      showDialogCancel: false,
      position: "center",
      duration: 20000,
      isInfinity: false,
      dContent: "",
      showSnackbar: false,
      dlgAlert: false,
      dlgAlertTitle: "",
      dlgAlertDetail: "",
      dlgConfirmDelete: false,
      showSidepanel: false,
      mode: "info",
      action: "add",
      titlePanel: "Infomation",
      pagination: {
        page: 0,
        total: 0,
        limit: 10,
        totalPage: 0,
        perPage: 20,
        keyword: ""
      },
      search: null,
      dataCustomerGroup: [],
      groupInfo: {},
      dlgConfirm: false,
      selected: null,
      customerGroup: {
        status: "active",
        group_name: "",
        customers: []
      },
      tempCustomer: [],
      showDetail: false,
      detailPromotion: [],
      detailCampaign: [],
      valueTab: "Promotion",
      scroll_start: [0],
      groupName: "",
      checkLoadData: true
    };
  },
  created() {
    this.getCustomerGroup();
  },
  methods: {
    handleScroll(event) {
      if (
        event.target.scrollTop + event.target.clientHeight >=
        event.target.scrollHeight
      ) {
        let page = this.pagination.page + 1;
        let keyword = this.pagination.keyword;
        let start = page * this.pagination.perPage + 1;

        this.onHandleScroll({
          page: page,
          perPage: 20,
          keyword: keyword,
          start: start
        });
      }
    },
    onHandleScroll(dataScroll) {
      this.loadData = true;
      this.pagination.page = dataScroll.page;
      this.pagination.keyword = dataScroll.keyword;
      this.pagination.start = dataScroll.start;

      // if (!this.scroll_start.includes(dataScroll.start)) {
      // this.scroll_start.push(dataScroll.start);
      if (this.checkLoadData) {
        customerGroupService.getAll(dataScroll).then(response => {
          if (dataScroll.page > 0) {
            for (let i = 0; i < response.data.length; i++) {
              this.dataCustomerGroup.push(response.data[i]);
            }

            if (response.data.length === 0) {
              this.checkLoadData = false;
            }

            this.loadData = false;
          } else {
            this.dataCustomerGroup = [];
            this.dataCustomerGroup = response.data;
            this.loadData = false;
          }
        });
      } else {
        this.loadData = false;
      }
    },
    onClickTab(vTab) {
      this.valueTab = vTab;
    },
    onClickClose() {
      this.valueTab = "Promotion";
      this.showDetail = false;
      this.showPromotion = false;
      this.showCampaign = true;
    },
    onOkWarning() {
      this.checkBackdrop = false;
    },
    onConfirm() {
      this.showSidepanel = false;
      this.checkBackdrop = false;
    },
    onCancel() {
      this.checkBackdrop = false;
    },
    saveGroup() {
      if (this.customerGroup.group_name.trim() === "") {
        // alert("Please select Group Name");
        this.dContent = "Please input Group Name";
        this.showSnackbar = true;
        return;
      }
      if (
        this.customerGroup.group_name.match(/([.!*+?^=!:${}()|\[\]\/\\])/g) !=
        null
      ) {
        this.dContent = "Group name not allow special characters";
        this.showSnackbar = true;
        this.$refs.formGroup.focusGroup();
        return;
      }

      if (this.customerGroup.customers.length < 1) {
        // alert("Please select customer");
        this.dContent = "Please select customer";
        this.showSnackbar = true;
        return;
      }

      // console.log("this.customerGroup ==>", this.customerGroup);

      customerGroupService
        .checkGroupName(this.customerGroup)
        .then(response => {
          if (response.data === "duplicate") {
            // alert("Duplicate Group Name.");
            this.dContent = "Duplicate Group Name.";
            this.showSnackbar = true;
            return false;
          } else {
            this.dlgConfirm = true;
            this.checkBackdrop = true;
          }
        })
        .catch(function(error) {
          _self.dlgAlert = true;
          _self.dlgAlertTitle = "Error!";
          _self.dlgAlertDetail = error.response.data.message;
        });
    },
    getCustomerGroup() {
      this.loadData = true;
      customerGroupService.getAll(this.pagination).then(response => {
        this.dataCustomerGroup = response.data;
        // this.pagination.total = response.total;
        // this.pagination.totalPage = Math.ceil(
        //   response.total / this.pagination.perPage
        // );
        this.loadData = false;
      });
    },
    addGroup() {
      this.mode = "add";
      this.action = "Create Customer Group";
      this.titlePanel = "Create Customer Group";
      // this.groupInfo = {};
      this.customerGroup = {
        status: "active",
        group_name: "",
        customers: []
      };
      this.showSidepanel = true;
    },
    editGroup() {
      this.mode = "edit";
      this.action = "Edit Customer Group";
      this.titlePanel = "Edit Customer Group";
      customerGroupService
        .checkIsActiveInCampaign(this.customerGroup._id)
        .then(response => {
          if (response === true) {
            this.dlgAlert = true;
            this.dlgAlertTitle = "Warning!";
            this.dlgAlertDetail = "Customer group is active in the campaign";
            this.checkBackdrop = true;
          }
        });
    },
    onSelect(item, type) {
      this.loadData = true;
      this.groupName = item.group_name;
      if (type == "edit") {
        this.mode = "info";
        this.titlePanel = "Group Infomation";
        this.selected = item._id;

        customerGroupService.getInfo(item._id).then(response => {
          this.customerGroup = response;
          this.showSidepanel = true;
          this.loadData = false;
        });
      } else {
        //view
        customerGroupService.getDetail(item._id).then(response => {
          this.detailPromotion = response.data.promotion;
          this.detailCampaign = response.data.campaign;
          this.showDetail = true;
          this.loadData = false;
        });
      }
    },
    closePanel() {
      // this.showSidepanel = false;
      this.showDialogCancel = true;
      this.checkBackdrop = true;
    },
    searchOnTable() {
      this.pagination.page = 0;
      this.scroll_start = [];
      this.checkLoadData = true;
      this.loadData = true;
      customerGroupService.getAll(this.pagination).then(response => {
        this.dataCustomerGroup = response.data;
        this.loadData = false;
      });
    },
    countMember(customer) {
      return customer.length;
    },
    // displayItem() {
    //   let start = this.pagination.page * this.pagination.perPage + 1;
    //   let end = start + this.pagination.perPage - 1;

    //   if (end > this.pagination.total)
    //     end = this.pagination.total.toLocaleString();

    //   return (
    //     start + "-" + end + " from " + this.pagination.total.toLocaleString()
    //   );
    // },
    // back() {
    //   this.pagination.page--;
    //   if (this.pagination.page < 0) this.pagination.page = 0;

    //   customerGroupService.getAll(this.pagination).then(response => {
    //     this.dataCustomerGroup = [];
    //     this.pagination.totalPage = Math.ceil(
    //       response.total / this.pagination.perPage
    //     );

    //     this.dataCustomerGroup = response.data;
    //     this.pagination.total = response.total;
    //   });
    //   this.$forceUpdate();
    // },
    // next() {
    //   this.pagination.page++;
    //   if (this.pagination.page >= this.pagination.totalPage)
    //     this.pagination.page = this.pagination.totalPage - 1;

    //   customerGroupService.getAll(this.pagination).then(response => {
    //     this.dataCustomerGroup = [];
    //     this.pagination.totalPage = Math.ceil(
    //       response.total / this.pagination.perPage
    //     );

    //     this.dataCustomerGroup = response.data;
    //     this.pagination.total = response.total;
    //   });
    //   this.$forceUpdate();
    // },
    displayMenber(member) {
      if (member.length > 0) return member.length;
      else return "";
    },
    onSort(sort) {
      console.log(sort);
    },
    onConfirmSaveGroup() {
      let _self = this;
      this.checkBackdrop = false;
      this.loadData = true;

      if (this.mode == "add") {
        // console.log("this.customerGroup ADD ==>", this.customerGroup);
        customerGroupService
          .saveGroup(this.customerGroup)
          .then(response => {
            this.pagination.page = 0;
            this.scroll_start = [];
            this.checkLoadData = true;
            this.loadData = true;
            this.getCustomerGroup();
            this.showSidepanel = false;
            // this.checkBackdrop = false;
          })
          .catch(function(error) {
            // console.log("error",error);
            //alert('error')
            //return Promise.reject(error)
            _self.dlgAlert = true;
            _self.dlgAlertTitle = "Error!";
            _self.dlgAlertDetail = error.response.data.message;
            // _self.checkBackdrop = false;
            _self.loadData = false;
          });
      } else {
        //console.log(this.customerGroup);
        let tempCustomer = [];
        tempCustomer = _.clone(this.customerGroup.tempCustomer);
        let custgroup_id = this.customerGroup._id;

        delete this.customerGroup.tempCustomer;

        this.customerGroup.modify_by = this.user.code;
        customerGroupService
          .updateGroup(this.customerGroup)
          .then(response => {
            this.pagination.page = 0;
            this.scroll_start = [];
            this.checkLoadData = true;
            this.loadData = true;
            this.getCustomerGroup();
            this.showSidepanel = false;
            this.checkBackdrop = false;
          })
          .catch(function(error) {
            _self.dlgAlert = true;
            _self.dlgAlertTitle = "Error!";
            _self.dlgAlertDetail = error.response.data.message;
            _self.checkBackdrop = false;
            _self.loadData = false;
          });

        if (tempCustomer && tempCustomer.length > 0) {
          customerGroupService
            .saveRemoveCustomer(custgroup_id, tempCustomer)
            .then(response => {});
        }
      }
    },
    onConfirmDelete() {
      this.checkBackdrop = false;
      this.loadData = true;
      customerGroupService
        .deleteGroup({ id: this.customerGroup._id, code: this.user.code })
        .then(response => {
          this.pagination.page = 0;
          this.scroll_start = [];
          this.checkLoadData = true;
          this.loadData = true;
          this.getCustomerGroup();
          this.showSidepanel = false;
          this.loadData = false;
        });
    },
    deleteGroup() {
      this.checkBackdrop = true;
      customerGroupService
        .checkGroupDelete({
          _id: this.customerGroup._id
        })
        .then(response => {
          if (response.data === "OK") {
            this.dlgConfirmDelete = true;
          } else {
            // alert("Can not delete customer group "+this.customerGroup.group_name);
            this.dContent =
              "Can not delete customer group " + this.customerGroup.group_name;
            this.showSnackbar = true;
            return false;
          }
        });
      //this.dlgConfirmDelete = true;
    },
    displayStatus(status) {
      if (status == "active") {
        return "<div style='color:green;weight:bold'>Active</div>"; //;//'<md-badge class="md-square md-primary" md-content="Active" />'
      } else {
        return "<div style=color:gray;weight:bold>Inactive</div>"; //</md-badge>';//'<md-badge class="md-square" md-content="Inactive" />'
      }
    },
    isOwner(item) {
      if (this.user.code == item.create_by) return true;
      else return false;
    },
    displayName(value) {
      let name = "";
      if (value.length > 0) {
        value.forEach(el => {
          name += el + ", ";
        });
      }
      return name.slice(0, -2);
    }
  }
};
</script>

<style lang="scss">
#customer-group-page {
  padding: 20px 15px 20px 20px;
  background-color: white;

  .head-title-page {
    font-size: 20px;
    font-weight: bold;
    margin: 5px;

    .head-label {
      padding-top: 8px;
    }

    .pageneg {
      text-align: right;
      padding-right: 10px;

      .md-icon-button {
        width: 30px;
        min-width: 30px;
        height: 30px;
        margin-top: 3px;
        margin-left: 5px;
      }

      .md-button.md-raised:not([disabled]) {
        box-shadow: 0 2px 1px -2px rgba(0, 0, 0, 0.2),
          0 0px 4px 0 rgba(0, 0, 0, 0.14), 0 1px 1px 0 rgba(0, 0, 0, 0.12);
      }
    }

    .pageneg-span {
      font-size: 15px;
      font-weight: normal;
      margin-top: 8px;
    }

    .filter-table {
      text-align: right;
      width: 30%;
      padding-right: 25px;
      padding-right: 15px;

      input {
        width: 100%;
        padding-left: 8px;
        height: 36px;
        border: 1px solid #ddd;
        border-radius: 5px;
        background: #fff;
      }

      ::placeholder {
        color: #bdbdbd;
        opacity: 1;
      }
    }

    .add-group {
      .md-button {
        margin: 0;
        height: 35px;
      }
    }
  }

  #table-customer-group {
    #divTableHead {
      width: 99.4%;
      display: -webkit-inline-box;
      font-size: 13px;
      font-weight: bold;
      margin-top: 15px;
      margin-bottom: 10px;

      div {
        // border: 1px solid pink;
        padding-left: 5px;
        padding-right: 5px;

        &.-text-right {
          text-align: right;
        }

        &.-text-center {
          text-align: center;
        }
      }
    }

    #divTableBody {
      width: 100%;
      height: calc(100vmin - 156px);
      display: block;
      overflow-y: scroll;
      font-size: 13px;

      > div {
        width: 100%;
        // height: 35px;
        display: -webkit-inline-box;
        padding-top: 5px;
        padding-bottom: 5px;

        div {
          // border: 1px solid pink;
          padding-left: 5px;
          padding-right: 5px;
          padding-top: 5px;

          &.-text-right {
            text-align: right;
          }

          &.-text-center {
            text-align: center;
          }

          &.nowrap-title {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }

      .md-icon-button {
        width: 30px;
        min-width: 30px;
        height: 30px;
      }

      .md-ripple,
      .md-button-content {
        padding-top: 0px !important;
      }
      .md-icon.more-vert {
        font-size: 20px !important;
      }

      .row-bg-gray:hover {
        border-radius: 4px;
        background: #ececeb;
      }

      &::-webkit-scrollbar {
        height: 7px;
        width: 5px;
      }
    }

    .footer-table {
      // border: 1px solid pink;
      display: block;
      text-align: center;
      margin-top: 5px;
      width: 99.6%;
      font-size: 14px;
      font-style: italic;
    }
  }

  .bg-backdrop {
    background: rgba(0, 0, 0, 0.6);
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 7;
    top: 0;
    left: 0;
  }
}

.md-menu-content-big.menu-vert {
  z-index: 20;
  top: 80px !important;
  left: unset !important;
  right: 205px !important;
}

.customer-group-dialog {
  width: 70%;
  height: 80%;
  z-index: 6 !important;
  transform: unset !important;
  top: 10% !important;
  left: 15% !important;

  .md-dialog-container {
    width: 100%;
  }

  .layout-dialog {
    margin: 0 18px 10px 25px;

    .md-layout {
      &.-head {
        padding-top: 10px;
        padding-left: 5px;
        height: 70px;

        .checkbox-status {
          padding-left: 25px;
          padding-top: 10px;
        }
      }

      //   &.-update {
      //     margin-top: 26px;
      //   }
    }
  }

  .md-dialog-title {
    &.md-title {
      font-size: 18px;
      margin-bottom: 0px;
      padding: 24px 30px 0;
    }

    .title-panel {
      position: fixed;
    }

    .md-menu {
      width: 102%;
      text-align: right;

      // .more-vert {
      //     height: 25px;
      //     width: 25px;
      //     min-width: 25px;
      // }
    }
  }

  .-action {
    position: fixed;
    padding: 8px 20px 10px 24px;
    bottom: 0px;
    margin-right: auto;
    margin-left: auto;
    width: 100%;

    .md-button {
      margin-right: 0px !important;
    }

    .md-ripple {
      width: 100%;
      margin: 0;
    }

    .-cancel {
      color: #727272 !important;
      margin-right: 10px;
    }
  }
}

.cg-view-dialog {
  width: 70%;
  height: 80%;
  z-index: 6 !important;
  transform: unset !important;
  top: 10% !important;
  left: 15% !important;

  .md-dialog-container {
    width: 100%;
  }

  .md-dialog-title {
    &.md-title {
      font-size: 18px;
      margin-bottom: 5px;
      padding: 24px 30px 0;
    }

    .md-menu {
      width: 102%;
      text-align: right;

      .more-vert {
        height: 25px;
        width: 25px;
        min-width: 25px;
      }
    }
  }

  .-mainshow {
    cursor: pointer;
    background-color: #ececec !important;
  }

  .-content {
    margin: 12px 25px 3px 25px;
    border: 1px solid #ddd;
    background-color: #f5f5f5;
  }

  .md-layout-item {
    &.-table {
      height: calc(80vmin - 155px);
      display: block;
      overflow-y: scroll;

      .-row {
        width: 101%;
        display: flex;
        padding: 8px 20px;

        .index {
          width: 5%;
        }

        .detail {
          width: 95%;
        }

        &.row-bg-gray:hover {
          border-radius: 4px;
          background: #ececeb;
        }
      }
    }
    &::-webkit-scrollbar {
      height: 7px;
      width: 7px;
    }
  }

  //   .md-tabs {
  //     margin-top: 5px;

  //     .md-button,
  //     .md-ripple {
  //       height: 35px;
  //     }

  //     .md-tabs-navigation {
  //       border-bottom: 1px solid rgba(128, 128, 128, 0.25);
  //     }

  //     .md-tab {
  //       height: calc(80vmin - 155px);
  //       display: block;
  //       overflow-y: scroll;

  //       .-row {
  //         width: 100%;
  //         display: flex;
  //         padding: 7px 20px;

  //         .index {
  //           width: 5%;
  //         }

  //         .detail {
  //           width: 95%;
  //         }

  //         &.row-bg-gray:hover {
  //           border-radius: 4px;
  //           background: #ececeb;
  //         }
  //       }

  //       &::-webkit-scrollbar {
  //         height: 7px;
  //         width: 7px;
  //       }
  //     }
  //   }

  .mktops-tab {
    width: 100%;
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
    box-shadow: 0 0px 0px -2px rgba(0, 0, 0, 0.2),
      0 0px 0px 0 rgba(0, 0, 0, 0.14), 0 1px 1px 0 rgba(0, 0, 0, 0.12);

    &.md-card.md-theme-default {
      height: 100%;

      .md-card-content {
        display: contents;

        > div {
          display: flex;
          padding-top: 15px;
          height: 50px;

          div {
            width: 18%;
            text-align: center;
            font-weight: 500;
            color: #727272;
            cursor: pointer;

            &.tab-active {
              border-bottom: 4px solid #3f51b5;
              color: #3f51b5;
            }
          }
        }

        .tab-chip {
          padding-left: 7px;
          padding-right: 7px;
          border-radius: 35px;
          color: white;
          font-size: 12px;
          padding-top: 3px;
          padding-bottom: 3px;
          margin-left: 5px;

          &.-chipgray {
            background-color: #9a9a9a;
          }
        }
      }
    }
  }

  .-action {
    position: fixed;
    padding: 8px 20px 10px 24px;
    bottom: 0px;
    margin-right: auto;
    margin-left: auto;
    width: 100%;

    .md-button {
      margin-right: 0px !important;
    }

    .md-ripple {
      width: 100%;
      margin: 0;
    }

    .-cancel {
      color: #727272 !important;
      margin-right: 10px;
    }
  }

  .bg-backdrop {
    background: rgba(0, 0, 0, 0.6);
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 7;
    top: 0;
    left: 0;
  }
}
</style>

<style lang="scss" scoped>
.table-data {
  font-size: 13px;
  th {
    text-align: left;
  }
  tr {
    padding: 3px;
    &:hover {
      cursor: pointer;
      background-color: rgba(236, 236, 235, 1);
    }
  }
  td {
    vertical-align: top;
  }

  .row-data {
    min-height: 35px;
  }
}

table {
  border-collapse: collapse;
  width: 100%;
}

th,
td {
  padding: 5px;
  text-align: left;
}
td {
  padding-left: 10px;
}

tr:hover {
  background-color: #f5f5f5;
}

th.sticky-header {
  position: sticky;
  top: -10px;
  z-index: 5;
  // #To not have transparent background.
  background-color: white;
  padding: 10px;
}
</style>
